import { render, staticRenderFns } from "./detailsPaid.vue?vue&type=template&id=697e5b7e"
import script from "./detailsPaid.vue?vue&type=script&lang=js"
export * from "./detailsPaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports